import React from "react";
import {Button, Checkbox, Container, Grid, Message, Modal, Header} from "semantic-ui-react";
import {ReactMic} from "react-mic";

//Used for recording pages pronunciation, translation flash cards, and dialog flash cards
function RecordDataComponent(
    {
        toggleRecording,
        record,
        onStop,
        onData,
        blobURL,
        handleSaveRecording,
        startQuiz,
        setOpen,
        open,
        handleToggleRecording,
        handleStartQuiz,
        handleStopQuiz,
        startRecording,
        stopRecording,
        success
    }
) {
    return (
        <>
            {
                startQuiz ?
                    <Button className='startQuiz' icon='stop' onClick={() => {
                        handleStopQuiz();
                        stopRecording();
                        setOpen(false)
                    }}
                            circular
                            style={{marginLeft: 10}} color='red'/>
                    :
                    <Modal
                        onClose={() => setOpen(false)}
                        onOpen={() => setOpen(true)}
                        open={open}
                        trigger={
                            <Button circular content='Quiz' className='startQuiz'
                                    color='green'
                                    icon='play'
                                    style={{marginLeft: 10}}/>
                        }>
                        <Modal.Header>Pronunciation Quiz</Modal.Header>
                        <Modal.Content>
                            <Modal.Description>
                                <p>
                                    A random card will change color and you need to say
                                    the
                                    correct
                                    pronunciation before the computer does.
                                    <br/>
                                    The pace will pick up as the quiz goes on.
                                </p>
                            </Modal.Description>
                        </Modal.Content>
                        <Modal.Actions>
                            <Checkbox
                                checked={toggleRecording}
                                label='Record Your Audio'
                                onChange={handleToggleRecording}
                            />
                            <Button
                                content="Start"
                                labelPosition='right'
                                icon='play'
                                className='startQuiz'
                                onClick={() => {
                                    handleStartQuiz();
                                    startRecording()
                                }}
                                positive
                            />
                        </Modal.Actions>
                    </Modal>
            }

            {toggleRecording ?
                <>
                    <Grid.Row>

                        <ReactMic
                            record={record}
                            className="sound-wave"
                            onStop={onStop}
                            onData={onData}
                            backgroundColor='grey'
                            strokeColor="green"
                            mimeType='audio/mp3'
                        />
                        < audio src={blobURL} controls="controls"
                                style={{marginTop: 20, marginLeft: 30}}/>
                    </Grid.Row>


                        {
                            blobURL ?
                                <Button onClick={handleSaveRecording}>Submit Recording</Button>
                                :
                                null
                        }
                    <Grid.Row>
                        {
                            success ?
                                <Message color='green'>
                                    <Header as='h1'>
                                        Successfully Uploaded!
                                    </Header>
                                </Message>
                                :
                                null
                        }
                    </Grid.Row>
                    <Grid.Row>
                    <Container>
                        <Message>
                            You may use the player to listen to your audio recording by pressing the Play button.<br/>
                            If you are satisfied with your recording, you may submit it by pressing the Submit Recording button.<br/><br/>
                            <b>Note: Your audio recording will only be used for academic purposes. Your recording will only be heard by your professor.</b>
                        </Message>
                    </Container>
                    </Grid.Row>
                </>
                :
                null
            }
        </>
    )
}

export default RecordDataComponent
